/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

/* action type */
import type { Action } from '../../store/state/state-manager';

export const OPEN_OBJECT_ACTION = 'OPEN_OBJECT_ACTION';

/* action creator */
export const openObjectAction = (actionPayload: Action['payload']) => {
  return {
    type: OPEN_OBJECT_ACTION,
    payload: actionPayload
  };
};
